
import { SET_PROJECT, UPDATE_ITEM,SET_MY_PROJECT,SET_TDK_PROJECT,SET_SELECTED_PROJECT } from '../constants/ActionTypes';



export const updateItem = (item,isUpdate) => {
    return { 
        type: UPDATE_ITEM,
        payload: {item, isUpdate}
    };
};


export const setProjects = (projects) => {
    return { 
        type: SET_PROJECT,
        payload: {projects}
    };
};
export const setTDKProjects = (projects) => {
    return { 
        type: SET_TDK_PROJECT,
        payload: {projects}
    };
};
export const setMyProjects = (myProjects) => {
    return { 
        type: SET_MY_PROJECT,
        payload: {myProjects}
    };
};
export const setSelectedProject = (selectedProject) => {
    return { 
        type: SET_SELECTED_PROJECT,
        payload: {selectedProject}
    };
};
